<template>
    <v-dialog :value="isPopupImport" max-width="500" persistent @click:outside="closeModal()">
        <v-card style="padding: 20px;">
            <template v-if="errorMessage">
                <v-alert type="error">{{ errorMessage }}</v-alert>
            </template>
          <div class="d-flex justify-between align-center">
              <div class="font-weight-bold text-sm-left " style="font-size: 18px;">
                  Chọn file sao kê
              </div>
              <v-spacer />
              <v-icon aria-label="Close" @click="closeModal()">mdi-close</v-icon>
          </div>
            <v-file-input
              accept=".xlsx,.csv,.xls"
              class="mt-1"
              variant="outlined"
              v-model="fileImport"
            />
          <div style="font-style: italic">
              file mẫu: <span>
              <a style="color:#1890FF " :href="linkExample" target="_blank">
              template_import.xlsx</a>
              </span>
          </div>
           <div class="d-flex align-center justify-end mt-2">
                   <v-btn @click="closeModal" type="primary" height="35px">Hủy</v-btn>
                   <v-btn @click="chooseFile" height="35px" class="primary" style="margin: 0 !important;">Tải lên</v-btn>
           </div>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    $_veeValidate: {
        validator: 'new'
    },
    props: {
        isPopupImport: {
            type: Boolean,
            default: false
        },
    },
    watch: {
        isPopupImport: {
            handler(value) {
                if(value) {
                    this.fileImport = ''
                }
            },
            deep: true
        }
    },
    data() {
        return {
            fileImport: '',
            showModal: false,
            errorMessage: '',
            linkExample: 'https://dphw5vqyyotoi.cloudfront.net/template_import_doisoatbank.xlsx?Expires=&Key-Pair-Id=K2TH38VR6QFQ8V&Signature=Hg-y9f7ksr0buL8hClvARjOnJw3E2Kj3FflOGgqxTV4mGTXppYhImE2zl-GmB8ytBolY0pMLBB2~UEKjtshXU4hbGO9fgYAx7tUTTo6cqRWMEFm70drlZuNK1Wjr3yfCy8sAxXUG1GgumLZmG06npPTBeXx468Nop9bkLR3~BwODfuPRRz8dLFO4vL1loyRZHiKPcSCBIhthl91alVT29a93-LllScf7PtbxofKiPDZh5G7Rzy2FOhZHxnp-w0xTrHb6wDKSthzpMBOchDzYyx1AzJ7MmcO0~0Oc7yYDJ17m9bihPlBnW7-msq8~RVAkGDU9xHLRlIoRr1HB8v3dwQ__',
        };
    },
    methods: {
       async chooseFile() {
          if(this.fileImport) {
              this.$emit("choose-file", this.fileImport);
              // this.fileImport = ''
          }else {
              this.$swal({
                  icon: 'error',
                  type: 'error',
                  title: "Lỗi",
                  text: "File không được để trống"
              });
          }
       },
        closeModal() {
            this.fileImport = ''
            this.$emit("closeModal");
        },
    }
};
</script>

<style scoped>
/deep/ .v-subheader.theme--light {
    font-size: 10px;
    font-weight: bold;
}
/deep/ .description-text{
    font-style: italic;
    font-weight: 100;
    font-size: 14px;
    line-height: 20px;
}
</style>